module.exports = __webpack_public_path__ + "img/LoginImage.6500936f.png";